<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>Cart</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="pt-2">
    <div class="d-flex align-items-center justify-content-end gap-2">
      <button class="btn btn-primary me-2" (click)="addSession()" *ngIf="!customerData?.isPassBuy && sessionId ==0"
        title="Add Session">
        <i class="fa-solid fa-plus me-1"></i>Add Session
      </button>
      <button class="btn btn-primary" (click)="addEvent()" title="Add Event">
        <i class="fa-solid fa-plus me-1"></i>Add Event
      </button>
    </div>
    <div class="mt-2 selectedCustomer">
      <div *ngIf="customerData && customerData != []" class="p-2">
        <div class="row selected-customer-details p-2">
          <h3 class="title">Customer Details</h3>
          <div class="d-flex align-items-center justify-content-start gap-1 mb-2 flex-wrap">
            <img [src]="customerData.images" (error)="customerImageHandler()" class="img-fluid profile-pic-table me-2"
              width="40px" alt="Not found" />
            <p class="mb-0 customer-name">
              {{ customerData.firstName }} {{ customerData.lastName }}
            </p>
          </div>
          <div class="col-sm-7">
            <div class="customer-info">
              Email: <span>{{ customerData.email }}</span>
            </div>
            <div class="customer-info">
              Phone: <span>{{ customerData.phoneNumber }}</span>
            </div>
            <div class="customer-info">
              Address: <span>{{customerData.fullAddress}}</span>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="customer-info">
              Order Date: <span [innerHTML]="currentDay | ordinalDate : currentDay"></span>
            </div>
            <div class="customer-info">
              Order Time: <span>{{currentDay | date: dateFormat.shortTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="customerData == null" class="select-customer-message">
        Customer needs to be selected.
      </div>

      <!-- Cart Changes below -->
      <div class="cart-box shopping-cart">
        <div class="table-responsive" *ngIf="cartData().length != 0">
          <table class="table">
            <thead>
              <tr>
                <th>SESSIONS & EVENTS</th>
                <th class="text-center">Rate</th>
                <th>SubTotal</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.cartData(); let i = index;">
                <td class="w-70" *ngIf="item.eventId>0">
                  <div class="table-details">
                    <img class="img-table img-resize" [src]="item.images" (error)="eventImageErrorHandler(item)" alt="">
                    <div class="card-body">
                      <h3 class="WrapData">{{item.name}}</h3>
                      <div class="card-one">
                        <div class="date-time-setion">
                          <h6 class="card-title mt-1">
                            <img src="../../../../assets/img/calendar-mini.svg " alt="">
                            <span [innerHTML]="item.startDateTime | ordinalDate : item.endDateTime"></span>
                          </h6>
                        </div>
                        <div class="date-time-setion">
                          <h6 class="card-title mt-1">
                            <i class="fa-regular fa-clock clock-img"></i>
                            <span class="date">{{item.startDateTime | date:dateFormat.shortTime}} - {{item.endDateTime |
                              date:dateFormat.shortTime}}</span>
                          </h6>
                        </div>
                        <div class="card-two ms-auto position-relative date-time-setion">
                          <h6 class="card-title mt-1">
                            <i class="fa-regular fa-user clock-img"></i>
                            <span class="date">Hosted By - {{item.hostName}}</span>
                          </h6>
                        </div>
                        <div class="card-two ms-auto position-relative date-time-setion">
                          <h6 class="card-title mt-1">
                            <img src="../../../../../assets/icons/event_location_icon.svg" class="mx-1" alt="">
                            <span class="date">{{item.eventAddress}}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="item.eventId > 0" class="text-center">
                  <h5 class="mx-auto w-100">{{currency.pound}}{{item.fees | number: '1.2-2'}}</h5>
                  <div class="stepper-input stepper__input">
                    <button class="toggle-less" (click)="removeItem(item)">
                      <i class="fa-solid fa-minus"></i>
                    </button>
                    <div class="stepper-input-field" name="range-value" aria-atomic="true" aria-live="polite"
                      aria-relevant="all">
                      {{item.qty}}
                    </div>
                    <button class="toggle-more" (click)="addItem(item)">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                  </div>
                </td>
                <td *ngIf="item.eventId >0" class="position-relative text-center">
                  <h5>{{currency.pound}}{{item.fees * item.qty | number: '1.2-2'}}</h5>
                </td>
                <td *ngIf="item.eventId >0" class="clear-cart clear-cart-event">
                  <div class="btn-close" (click)="removeItemFromCart(item)">
                    <i class="fa fa-times"></i>
                  </div>
                </td>
                <td class="w-70" *ngIf="item.paymentPassId>0">
                  <div class="table-details">
                    <img class="img-table img-resize" src="../../../../../assets/img/passes.svg" alt="">
                    <div class="card-body">
                      <h3 class="WrapData">{{item.name}}</h3>
                      <div class="card-one">
                        <div class="date-time-setion">
                          <h6 class="card-title mt-1">
                            <img src="../../../assets/img/calendar-mini.svg " alt="">
                            <span [innerHTML]="sessionData.sessionStartDateTime | ordinalDate : sessionData.sessionEndDateTime"></span>
                          </h6>
                        </div>
                        <div class="date-time-setion">
                          <h6 class="card-title mt-1">
                            <i class="fa-regular fa-clock clock-img"></i>
                            <span class="date">{{sessionData.sessionStartDateTime | date:dateFormat.shortTime}} -
                              {{sessionData.sessionEndDateTime | date:dateFormat.shortTime}}</span>
                          </h6>
                        </div>
                        <div class="card-two ms-auto position-relative date-time-setion">
                          <h6 class="card-title mt-1">
                            <i class="fa-regular fa-user clock-img"></i>
                            <span class="date">Hosted By - {{sessionData.hostedBy}}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="item.paymentPassId > 0">
                  <h5>{{currency.pound}} {{ item.fees | number : "1.2-2" }}</h5>
                </td>
                <td *ngIf="item.paymentPassId > 0" class="position-relative ">
                  <h5>{{currency.pound}} {{ item.amount | number : "1.2-2" }}</h5>
                </td>
                <td *ngIf="item.paymentPassId > 0" class="clear-cart">
                  <div class="btn-close" (click)="removeItemFromCart(item)">
                    <i class="fa fa-times"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="coupon-section pb-3 border-bottom pt-lg-0 pt-3" *ngIf="cartData().length != 0">
          <div class="row">
            <div class="col-md-6">
              <div class="promo-code">
                <div>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" [(ngModel)]="couponName"
                      oninput="this.value = this.value.replace(/^\s+/g, '')" placeholder="Enter your coupon code"
                      aria-label="Enter promo code" aria-describedby="basic-addon2"
                      (ngModelChange)="onChangePromoCode($event)" />
                    <i class="clear-btn fa fa-times" *ngIf="couponName !=''" (click)="removeCoupon()"></i>
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="button" (click)="applyCouponCode()">
                        Add
                      </button>
                    </div>
                  </div>
                  <div class="coupon_main mb-3" *ngIf="isCouponApplied">
                    <div class="left-part">
                      <p class="code mb-0">{{ appliedCouponName }}</p>
                    </div>
                    <div class="coupon_border"></div>
                    <div class="right-part">
                      <p class="percent">
                        <span *ngIf="discountType === 1">{{currency.pound}} {{ couponDiscountedValue }}</span>
                        <span *ngIf="discountType === 2">{{ couponDiscountedValue }}%</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="row" *ngIf="cartData().length != 0">
                  <div class="col-lg-12 col-12">
                    <div class="mb-3">
                      <!-- <mat-label>Select Payment Type<span class="text-danger">*</span> </mat-label> -->
                      <mat-form-field style="width: 100%">
                        <mat-select placeholder="Select Payment Type" [(ngModel)]="selectedPaymentType">
                          <mat-option *ngFor="let item of paymentTypeList"
                            [value]="item.paymentTypeId">{{item.paymentTypeName}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-error *ngIf="selectedPaymentType == null && isOrderFormSubmitted">
                        Payment type is required
                      </mat-error>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="cartData().length != 0">
                  <div class="col-lg-12 col-12">
                    <div class="mb-3">
                      <!-- <mat-label>Remarks</mat-label> -->
                      <mat-form-field style="width: 100%">
                        <textarea matInput maxlength="500" placeholder="Order Remarks"
                          oninput="this.value = this.value.replace(/^\s+/g, '')" [(ngModel)]="orderRemarks"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="total-section">
                <ul>
                  <li>
                    <div class="cart-section">
                      <p>SubTotal :</p>
                      <span>{{currency.pound}} {{ subtotal() | number : "1.2-2" }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="cart-section">
                      <p>
                        Tax <label>({{ taxPercentage() }}%) :</label>
                      </p>
                      <span>{{currency.pound}} {{ calculatedTax() | number : "1.2-2" }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="cart-section" *ngIf="isCouponApplied">
                      <p>Discount <label><span class="p-0" *ngIf="discountType === 1">({{currency.pound}}
                            {{couponDiscountedValue}})</span><span class="p-0"
                            *ngIf="discountType === 2">({{couponDiscountedValue}}%)</span></label> :</p>
                      <span class="p-0">{{currency.pound}} {{ this.discountType == 1 ? this.alltotal() -
                        this.discountValue() <= 0 ? this.subtotal() + this.calculatedTax() : this.discountValue() :
                          this.discountValue() | number : "1.2-2" }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="total-cart">
                      <div class="cart-section">
                        <p>Total &nbsp;&nbsp; :</p>
                        <span>{{currency.pound}} {{ totalValue() | number : "1.2-2" }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end gap-2 py-3 pe-3 cart-btn-group flex-wrap"
        *ngIf="cartData().length != 0">
        <!-- <button class="btn btn-primary-outline">
          <input type="checkbox" [(ngModel)]="isFitToPracticeYoga">
          Are You Fit to Practice / Not Pregnant ?
        </button> -->
        <button class="btn btn-primary-outline" (click)="selectPrintReceipt()">
          <input type="checkbox" [(ngModel)]="isDownloadReceipt">
          Print Receipt
        </button>
        <button class="btn btn-primary-outline" (click)="selectSendEmail()">
          <input type="checkbox" [(ngModel)]="isSendEmail" />
          Send Email
        </button>
      </div>
    </div>

    <div class="cart-box shopping-cart text-center" *ngIf="cartData().length == 0">
      <div>
        <img src="../../../../../assets/img/EmptyCart.png" width="300" height="300" alt="" class="img-fluid">
      </div>
      <div>
        <h5>Your cart is empty</h5>
      </div>
    </div>
    <!-- </div> -->

    <div class="text-center mt-3 d-flex align-items-center justify-content-center gap-2 flex-wrap">
      <button class="btn btn-primary" (click)="addNewOrder()" [disabled]="cartData().length ==0">Submit</button>
      <button class="btn btn-primary-outline previous-btn" (click)="cancel()">Cancel</button>
    </div>
  </mat-dialog-content>
</div>